<template>
    <div class="resourceEdit">
        <el-dialog :visible.sync="editVisible" @close="cleanForm('addResourceForm')" title="新增资源">
            <el-form :model="editResourceObj" status-icon :rules="rules" label-width="80px" ref="addResourceForm" class="ruleForm">
                <el-form-item label="资源名称" prop="resourceName">
                    <el-input class="margin-space" placeholder="请输入资源名称" v-model="editResourceObj.resourceName">
                    </el-input>
                </el-form-item>
                <el-form-item label="apiUrl" prop="apiUrl">
                    <el-input class="margin-space" placeholder="请输入URL" v-model="editResourceObj.apiUrl">
                    </el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remarks">
                    <el-input class="margin-space" placeholder="请输入备注" v-model="editResourceObj.remarks">
                    </el-input>
                </el-form-item>
                <el-form-item label="请求方式" prop="method">
                    <el-radio 
                        v-for="item in resourceTypes" :key="item.key" 
                        v-model="editResourceObj.method" 
                        :label="item.key">
                        {{item.value}}
                    </el-radio>
                </el-form-item>
                <div style="text-align: right" class="margin-space">
                    <div style="text-align: right" class="margin-space">
                        <el-button :loading="editLoading" type="primary" @click="editConfirmClick('addResourceForm')">
                        修改
                    </el-button>
                    </div>
                </div>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import axios from 'axios'
export default {
    name:'resourceEdit',
    data(){
        let urlCheck = (rule, value, callback) => {
            let reg = /^\/(a-z0-9)*/
            // console.log(reg.test(value))
            if (!reg.test(value)) {
                callback(new Error("请输入以'/'开头的URL"));
            } else {
                callback();
            }
        };
        return {
            resourceTypes:[
                {key:'GET',value:'GET'},
                {key:"POST",value:'POST'},
                {key:"DELETE",value:'DELETE'},
                {key:"PUT",value:'PUT'},
            ],
            editVisible:false,
            editResourceObj:{},
            editLoading:false,
            rules:{
                resourceName:[
                    {required:true,message:'资源名称不能为空',trigger:'blur'}
                ],
                apiUrl:[
                    {required:true,message:'apiURL不能为空',trigger:'blur'},
                    {validator:urlCheck,trigger:'blur'}
                ]
            }
        }
    },
    methods:{
        cleanForm(formName){
            this.$refs[formName].resetFields();
        },
        setVisible(flag,data){
            this.editVisible = flag;
            this.editResourceObj = data;
        },
        editConfirmClick(formName) {
            this.$refs[formName].validate(async valid => {
                if(valid){
                    this.editLoading = true
                    let data = {
                        resourceName: this.editResourceObj.resourceName,
                        remarks: this.editResourceObj.remarks,
                        apiUrl: this.editResourceObj.apiUrl,
                        method: this.editResourceObj.method,
                        id: this.editResourceObj.id,
                    }
                    let r = await axios.post('/admin/resource/edit', data)
                    if(r.code == 0){
                        this.$message.success('修改成功')
                    }else{
                        this.$message.error(r.msg)
                    }
                    this.editLoading = false
                    this.editVisible = false
                    this.$emit('update');
                }
            })
        },
    }
}
</script>

<style>
    
</style>


// WEBPACK FOOTER //
// src/main/permission/components/ResourceEdit.vue